import React from 'react';
import PropTypes from 'prop-types';
import Slot from './Slot';


class Schedule extends React.Component {
    state = {
      currentHover: null,
      productDuration: 80,
    };

    componentDidUpdate(prevProps, prevState) {
      const {
        items, duration, resourceTimeStep, activeDate,
      } = this.props;

      if (prevProps.activeDate !== activeDate ||
      prevProps.duration !== duration) {
        const { currentClicked } = this.state;

        // const currentTime = items.time.find(({date}) => date === activeDate);

        if (activeDate === undefined) {
          return;
        }

        let currentIndexFromDate;

        if (activeDate !== undefined && activeDate.date === items.date) {
          currentIndexFromDate = items.time.findIndex(({ time }) => time === activeDate.start);
        }

        const slots = (duration / resourceTimeStep);

        const nextBlockIndex = currentIndexFromDate + slots;


        const incompleteBlock = items.time.slice(currentIndexFromDate, nextBlockIndex)
          .filter(slot => slot.status !== 'open')
          .length > 0;

        const divider = items.time.slice(currentIndexFromDate, nextBlockIndex)
          .filter(slot => slot.status === 'divider')
          .length > 0;


        if (incompleteBlock && items.date === activeDate.date) {
          if (divider) {
            // Om alla blocken som inte är open är divided, gör inget. Det är samma sak som om det är okej
            return;
          }

          alert('Tyvärr blev tiden nu längre när du bytte produkt. Den får ej längre plats. Var god välj en ny.');

          this.props.onDateChange(undefined);
        }
      }
    }


    handleMouseEnter = index => (event) => {
      // We don't care about the actual event, so we just disregard that
      this.setState({ currentHover: index });
    };

    // Here, we don't event use the variable event (this is more accepted)
    handleMouseOut = index => () => {
      this.setState({ currentHover: null });
    };

    handleClick = date => () => {
      this.setState({
        currentClicked: date.index,
      });

      this.props.onDateChange({ date: date.date, start: date.start, end: date.end });
    };

    PlacementChecker = (fs) => {
      if (fs === 1) {
        return false;
      }

      return true;
    };

    render() {
      const {
        productDuration, currentHover,
      } = this.state;
      const { items, timeStep } = this.props;
      const {
        activeDate, duration, resourceTimeStep, masterData, bookingData, productId
      } = this.props;


      let activeDuration = duration;


      if (items === undefined) {
        return <div>No items</div>;
      }

      if (activeDuration === undefined) {
        activeDuration = resourceTimeStep;
      }

      const slots = (activeDuration / resourceTimeStep) - 1;


      let currentIndexFromDate;

      if (activeDate !== undefined && activeDate.date === items.date) {
        currentIndexFromDate = items.time.findIndex(({ time }) => time === activeDate.start);
        console.log(currentIndexFromDate);
      }


      return (
        <td>
          {items.time.map((currentSlot, index) => {
              // Hover variables
              const nextBlockIndex = currentHover + slots + 1;
              const lastBlockIndex = currentHover + slots;

              const nextSlot = items.time[nextBlockIndex];
              const lastSlot = items.time[lastBlockIndex];
              const lastBlockIndexRender = index + slots + 1;


              // Click variables
              const nextSlotClicked = items.time[currentIndexFromDate + slots + 1];
              const endTimeBlock = items.time[index + slots + 1];


                    const clicked =
                        activeDate !== undefined &&
                        currentIndexFromDate !== undefined &&
                        activeDate.date === items.date &&
                      index >= currentIndexFromDate &&
                        index <= currentIndexFromDate + slots;

                    const hoverActive = currentHover !== null &&
                        index >= currentHover &&
                        index <= currentHover + slots &&
                        nextSlot !== undefined;

                    const isLastHover = hoverActive && index === currentHover + slots;
                    const isBetweenHover = hoverActive &&
                        isLastHover === false &&
                        index !== currentHover;

                    const isLastClicked = clicked && index === currentIndexFromDate + slots;


                    const isBetweenClick = clicked &&
                          isLastClicked === false &&
                          index !== currentIndexFromDate;

                    const incompleteBlock = items.time.slice(currentHover, nextBlockIndex)
                            .filter(slot => slot.status !== 'open')
                            .length > 0;

                    const isOccupied = currentHover !== null && items.time[currentHover].type === 'occupied';

            const bookedOverlap = items.time.slice(currentHover, nextBlockIndex)
                            .filter(slot => slot.status === 'booked')
                            .length > 0 || isOccupied;


                    const spotOn = items.time.slice(currentHover, nextBlockIndex)
                        .filter(slot => slot.status === 'divider')
                        .length > 0;


                    const spotOnFirst = currentHover !== null && items.time[currentHover].type === 'first' &&
                        items.time[currentHover + slots].type === 'last' &&
                        index >= currentHover &&
                        index <= currentHover + slots;

                    /*
                    const spotOnLast = currentSlot.type === 'last' &&
                        items.time[index - slots].type === 'first';


                  Vi låtsas som om det finns 12 lediga.

*/
                    const spotOnMatch = spotOnFirst;

                    const drawspotOn = items.time.slice(index, lastBlockIndexRender)
                        .filter(slot => slot.status === 'divider')
                        .length > slots;

                    const placementChecker2 =
                      index >= currentHover &&
                      index <= currentHover + slots;

                    const placementChecker = placementChecker2 &&
                      items.time[currentHover] !== undefined &&
                      items.time[currentHover].fs === 'no';


                    const payload = {
                        date: items.date,
                        start: currentSlot.time,
                        end: endTimeBlock !== undefined ? endTimeBlock.time : '',
                        lastSlot: lastSlot !== undefined ? lastSlot.time : '',
                        index,
                    };

                    const showMaster = masterData && currentSlot.time >= masterData.date.start &&
                        currentSlot.time <= masterData.date.end;

                    //console.log(bookingData);

                    const ShowOtherBooking = bookingData
                    .filter(( {date, id} ) => currentSlot.time >= date.start &&
                        currentSlot.time <= date.end && date.date === items.date && id !== productId).length >= 1;

            const filterBookings = bookingData
                .filter(( {date, id} ) => currentSlot.time > date.start &&
                    currentSlot.time < date.end && date.date === items.date && id !== productId);

            const betweenOtherBooking = filterBookings.length >= 1;

            const productName = filterBookings && filterBookings[0] ? filterBookings[0].productName : undefined;


            //const productName = 'hej';




                    return (
                      <div
                        key={index}
                        onMouseEnter={this.handleMouseEnter(index)}
                        onMouseOut={this.handleMouseOut(index)}
                      >
                        <Slot
                          clicked={clicked}
                          incompleteBlock={incompleteBlock}
                          bookedOverlap={bookedOverlap}
                          spotOn={spotOn}
                          spotOnMatch={spotOnMatch}
                          drawSpotOn={drawspotOn}
                          slot={currentSlot}
                          nextSlot={nextSlot}
                          nextSlotClicked={nextSlotClicked}
                          placementChecker={placementChecker}

                          isOccupied={isOccupied}
                          showMaster={ShowOtherBooking}
                          informationBetween={betweenOtherBooking}
                          productName={productName}

                          hoverActive={hoverActive}
                          isBetweenHover={isBetweenHover}
                          isLastHover={isLastHover}
                          isBetweenClick={isBetweenClick}
                          isLastClick={isLastClicked}
                          onClick={this.handleClick(payload)}
                        />
                      </div>
                    );
                })}
        </td>
      );
    }
}

Schedule.propTypes = {
  onDateChange: PropTypes.func.isRequired,
};

export default Schedule;



// WEBPACK FOOTER //
// ./src/components/Resource/components/Schedule.jsx